import { forwardRef } from 'react';

import { SvgStyled } from '@sternum/web/icons/icons.styles';
import { IconProps } from '@sternum/web/icons/icons.types';

export const KPIWidgetIcon = forwardRef<SVGSVGElement, IconProps>(function KPIWidgetIcon(
  { height = 32, width = 32, hasCursorPointer = false, ...props },
  ref,
) {
  return (
    <SvgStyled
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 32 32"
      data-has-cursor-pointer={hasCursorPointer}
      {...props}
    >
      <path d="M6.22253 8V24H3.59376V11.682L0 14.6053V11.3919L4.40347 8H6.22253Z" fill="#5137A1" />
      <path d="M13.5432 8H24.3577V9.82985L17.6471 24H14.6745L21.1078 10.5886H13.5432V8Z" fill="#5137A1" />
      <path d="M32 8V24H29.3712V11.682L25.7775 14.6053V11.3919L30.1809 8H32Z" fill="#5137A1" />
      <path
        d="M9.59492 24C9.14794 24 8.76868 23.8457 8.45714 23.537C8.15238 23.2283 8 22.851 8 22.4051C8 21.9524 8.15238 21.5717 8.45714 21.263C8.76868 20.9543 9.14794 20.8 9.59492 20.8C10.0487 20.8 10.4279 20.9543 10.7327 21.263C11.0442 21.5717 11.2 21.9524 11.2 22.4051C11.2 22.851 11.0442 23.2283 10.7327 23.537C10.4279 23.8457 10.0487 24 9.59492 24Z"
        fill="#EF145D"
      />
    </SvgStyled>
  );
});
